import { rideOptions } from '../../utils/constants';

export function VehiclePreference({ comfortLevel }: { comfortLevel: string }) {
  const option = rideOptions[comfortLevel as keyof typeof rideOptions];
  
  return (
    <div className="border rounded-lg p-4">
      <h3 className="font-semibold mb-2">Vehicle Preference</h3>
      <p className="text-sm">
        <span className="text-gray-600">Comfort Level:</span> {option?.name}
      </p>
      <ul className="mt-2 text-sm text-gray-600">
        {option?.features.map((feature, index) => (
          <li key={index} className="flex items-center">
            <span className="mr-2">•</span> {feature}
          </li>
        ))}
      </ul>
    </div>
  );
}